module.exports = __webpack_public_path__ + "assets/adpoly-facility-prayer-rooms-bulk-upload-template.616fbbff.xlsx";